import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Organization } from 'src/app/classes/organization';
import { Payment } from 'src/app/classes/payment';
import { PaymentService } from 'src/app/services/payment.service';
import { SettingsService } from 'src/app/services/settings.service';
import PaymentStatuses from 'src/app/constants/payment-statuses';
import PaymentResultCodesTbc from 'src/app/constants/payment-result-codes-tbc';
import { ShiftService } from 'src/app/services/shift.service';
import { Capacitor } from '@capacitor/core';
import { Shift } from 'src/app/classes/shift';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Browser } from '@capacitor/browser';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { CustomerService } from 'src/app/services/customer.service';
import { LocationService } from 'src/app/services/location.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit {

  organization = new Organization()
  currentUser: CustomerContact = new CustomerContact()
  payment = new Payment()
  paymentStatuses = PaymentStatuses
  paymentResultCodesTbc = PaymentResultCodesTbc

  retryShift!: Shift

  retryForm = new FormGroup({
    card: new FormControl<string | number | null>('new_card', [Validators.required]),
  })

  constructor(private settingService: SettingsService,
    private shiftService: ShiftService,
    private paymentService: PaymentService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    public router: Router,
    public locationService: LocationService,
    private titleService: Title,
    @Inject(LOCALE_ID) public locale: string
  ) { }

  ngOnInit() {
    this.settingService.organization().subscribe(organization => {
      this.organization = organization
    })

    this.customerService.current().subscribe(contact => {
      this.currentUser = contact
    })

    this.route.params.subscribe(params => {
      if (params['paymentId']) {
        this.titleService.setTitle($localize`Payment` + ' ' + params['paymentId'])

        this.paymentService.get(params['paymentId']).subscribe(payment => {
          this.payment = payment

          if(this.payment.status == 'success') {
            this.locationService.updateBalance()
          }
        })

        this.paymentService.wait(`${params['paymentId']}`).subscribe(async (payment) => {
          this.payment = payment
          
          if(this.payment.status == 'success') {
            this.locationService.updateBalance()
          }
          
          if (payment.status == 'success')
            alert($localize`Payment successful.`)
          else if (payment.status == 'failed')
            alert($localize`Payment failed.`)
          this.payment = payment
        })
      }
    })
  }

  retry() {
    const platform = Capacitor.getPlatform()

    this.shiftService.shift(this.payment.shift_id).subscribe(shift => {
      
      this.paymentService.payment('tbc', { card: this.retryForm.controls.card.value, shift: shift, locale: this.locale, platform: platform }).subscribe(async payment => {

        if (this.retryForm.controls.card.value == 'new_card') {
          if (platform != 'web') {
            await Browser.open({ url: payment.redirect_url })

            Browser.addListener('browserFinished', () => {
              this.router.navigate(['/payments', payment.id])
            })

            this.paymentService.wait(`${payment.id}`).subscribe(async (payment) => {
              await Browser.close()
              this.router.navigate(['/payments', payment.id])
            })
          }
          else {
            location.href = payment.redirect_url
          }
        }
        else {
          this.router.navigate(['/payments', payment.id])
        }
      })

    })
  }
}
